import React, { useState, useRef } from 'react';
import './AdminPanel.css';
import API_URL, { parseJsonResponse } from '../api';
import { TL_ACCOUNT_OPTIONS, ACCOUNT_DREAME } from '../constants/accountOptions';

function UserManagement() {
  const [tlUsername, setTlUsername] = useState("");
  const [tlPassword, setTlPassword] = useState("");
  const [tlName, setTlName] = useState("");
  const [tlCreatedAt, setTlCreatedAt] = useState("");
  const [tlPosition, setTlPosition] = useState("");
  const [photoBase64, setPhotoBase64] = useState("");
  const [tlRfid, setTlRfid] = useState("");
  const [tlEid, setTlEid] = useState("");
  const [tlAccount, setTlAccount] = useState(ACCOUNT_DREAME);

  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPhotoBase64(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleRegisterTL = async (e) => {
    e.preventDefault();

    if (!tlUsername || !tlPassword || !tlName || !tlRfid || !tlEid || !tlCreatedAt || !tlPosition || !tlAccount || !photoBase64) {
      alert("Mangyaring kumpletuhin ang lahat ng impormasyon at mag-upload ng litrato.");
      return;
    }

    const payload = {
      action: 'register_tl',
      username: tlUsername,
      password: tlPassword,
      tlName: tlName,
      tlCreatedAt: tlCreatedAt,
      tlPosition: tlPosition,
      photoBase64: photoBase64,
      rfid: tlRfid,
      eid: tlEid,
      account: tlAccount,
    };

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await parseJsonResponse(response);

      if (data?.status === 'success') {
        alert("Success! " + data.message);
        setTlUsername("");
        setTlPassword("");
        setTlName("");
        setTlCreatedAt("");
        setTlPosition("");
        setPhotoBase64("");
        setTlRfid("");
        setTlEid("");
        setTlAccount(ACCOUNT_DREAME);
      } else {
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("Hindi maka-konekta sa database server. Siguraduhing umaandar ang XAMPP/Local server mo.");
    }
  };

  return (
    <div className="admin-form-wrapper">
      <div className="admin-form-panel">
        <h2 className="admin-form-title">New Team Leader</h2>
        <p className="admin-form-subtitle">Register a new TL account with RFID credentials</p>

        <div className="admin-photo-section">
          <div className="admin-photo-box" onClick={() => fileInputRef.current.click()}>
            {photoBase64 ? (
              <img src={photoBase64} alt="TL" className="admin-photo-preview" />
            ) : (
              <span className="admin-photo-placeholder">2×2<br />PHOTO</span>
            )}
          </div>
          <button type="button" className="admin-upload-btn" onClick={() => fileInputRef.current.click()}>
            Upload 2×2 Photo
          </button>
          <input type="file" ref={fileInputRef} onChange={handleFileChange} style={{ display: 'none' }} accept="image/*" />
        </div>

        <form onSubmit={handleRegisterTL} autoComplete="off">
          <div className="admin-form-row">
            <div className="admin-form-col">
              <label className="admin-form-label">Username</label>
              <input type="text" className="admin-form-input" placeholder="Enter Username" value={tlUsername} onChange={(e) => setTlUsername(e.target.value)} autoComplete="new-password" />
            </div>
            <div className="admin-form-col">
              <label className="admin-form-label">Password</label>
              <input type="password" className="admin-form-input" placeholder="Enter Password" value={tlPassword} onChange={(e) => setTlPassword(e.target.value)} autoComplete="new-password" />
            </div>
          </div>

          <div className="admin-form-group">
            <label className="admin-form-label">Full Name</label>
            <input type="text" className="admin-form-input" placeholder="Enter Complete Name" value={tlName} onChange={(e) => setTlName(e.target.value)} />
          </div>

          <div className="admin-form-row">
            <div className="admin-form-col">
              <label className="admin-form-label">Employee UID (RFID)</label>
              <input type="text" className="admin-form-input" placeholder="Scan RFID Tag" value={tlRfid} onChange={(e) => setTlRfid(e.target.value)} />
            </div>
            <div className="admin-form-col">
              <label className="admin-form-label">Employee EID</label>
              <input type="text" className="admin-form-input" placeholder="e.g. H-2025-001" value={tlEid} onChange={(e) => setTlEid(e.target.value)} />
            </div>
          </div>

          <div className="admin-form-row">
            <div className="admin-form-col">
              <label className="admin-form-label">Created At</label>
              <input type="date" className="admin-form-input" value={tlCreatedAt} onChange={(e) => setTlCreatedAt(e.target.value)} />
            </div>
            <div className="admin-form-col">
              <label className="admin-form-label">Position</label>
              <select className="admin-form-input" value={tlPosition} onChange={(e) => setTlPosition(e.target.value)}>
                <option value="">-- Select Position --</option>
                <option value="Team Leader">Team Leader</option>
                <option value="Senior Team Leader">Senior Team Leader</option>
              </select>
            </div>
          </div>

          <div className="admin-form-group">
            <label className="admin-form-label">Account</label>
            <select className="admin-form-input" value={tlAccount} onChange={(e) => setTlAccount(e.target.value)} required>
              {TL_ACCOUNT_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            <p className="admin-form-hint" style={{ marginTop: 8, fontSize: '0.85rem', opacity: 0.75 }}>
              ALL = makikita ang DREAME Logs at MEGELIN Logs. DREAME o MEGELIN = isang account lang ang visible.
            </p>
          </div>

          <button type="submit" className="admin-submit-btn">Register TL</button>
        </form>
      </div>
    </div>
  );
}

export default UserManagement;
